import { render, staticRenderFns } from "./SidebarConfig.vue?vue&type=template&id=efc01a32&scoped=true"
import script from "./SidebarConfig.vue?vue&type=script&lang=js"
export * from "./SidebarConfig.vue?vue&type=script&lang=js"
import style0 from "./SidebarConfig.vue?vue&type=style&index=0&id=efc01a32&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efc01a32",
  null
  
)

export default component.exports